import * as Sentry from '@sentry/sveltekit';
import posthog from 'posthog-js';
import { dev } from '$app/environment';
import { env } from '$env/dynamic/public';
import { sentryConfig, isSentryEnabled } from '$lib/sentry/config';

// Design Ref: §2.1 — Sentry는 PostHog보다 먼저 init하여 init 시점 에러도 캡처
if (isSentryEnabled) {
	Sentry.init({
		...sentryConfig,
		integrations: [Sentry.browserTracingIntegration()]
	});
}

export async function init() {
	if (dev) return;
	if (!env.PUBLIC_POSTHOG_PROJECT_TOKEN) return;

	posthog.init(env.PUBLIC_POSTHOG_PROJECT_TOKEN, {
		api_host: '/ingest',
		ui_host: 'https://us.posthog.com',
		defaults: '2026-01-30',
		// Plan SC: Sentry/PostHog 역할 분리 — 예외 캡처는 Sentry 단일화
		capture_exceptions: false,
		disable_session_recording: true
	});
}

/** @type {import('@sveltejs/kit').HandleClientError} */
export const handleError = Sentry.handleErrorWithSentry();
